export default "__VITE_ASSET__DD$4JNSS__"